import React from 'react';
import { Route, withRouter } from 'react-router-dom';
import BookingInfo from './BookingInfo.jsx';

const Widget = ({ match }) => {
  return (
    <Route
      exact={false}
      path={`${match.url}/partner/booking/:bookingCode`}
      component={BookingInfo}
    />
  );
};

export default withRouter(Widget);
